(ns pfo.search.model
  (:require [pfo.api :as api]))

(defn search [query page]
  (api/ajaxp "/search/" {:params {:query query
                                  :page page}}))
